import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { FolderDetails, FolderDetailsGroup } from '../viewModels/FolderDetails';
import { GetFolderPayload, UserGroupFolderParams } from './generated/types';

const mapToGroupFolderDetailsViewModel = (source: Array<UserGroupFolderParams>): Array<FolderDetailsGroup> =>
    source.map(item => ({ groupId: item.groupId, inherited: item.inherited }));

export const useGetFolderDetails = (folderId: string | undefined) => {
    const context = useContext(AppContext);
    const query = `query GetFolder {
          getFolder(id: "${folderId}") {
              folder {
                id
                editorGroups {
                    groupId
                    inherited
                }
                readerGroups {
                    groupId
                    inherited
                }
                isEmpty
              }
            }
      }`;
    return useQuery(
        {
            queryKey: ['GetFolder', folderId],
            queryFn: async (): Promise<FolderDetails> => {
                const response = await (context.api.graphql({ query }) as Promise<{
                    data: {
                        getFolder: GetFolderPayload;
                    };
                }>);

                const source = response.data.getFolder.folder!;

                return {
                    editorGroups: mapToGroupFolderDetailsViewModel(source.editorGroups!),
                    readerGroups: mapToGroupFolderDetailsViewModel(source.readerGroups!),
                    isEmpty: source.isEmpty!,
                };
            },
            enabled: !!folderId,
            refetchOnWindowFocus: false,
            staleTime: 0,
            gcTime: 0,
        },
    );
};

// NOTE: https://react-query.tanstack.com/guides/query-functions#using-a-query-object-instead-of-parameters